import styled from 'styled-components';

const ContentContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
`;

export default ContentContainer;
